<div class="form-group">
  <label class="mb-3" [for]="name" *ngIf="label">{{placeholder | titlecase}}</label>
  <p-slider [step]="step" (ngModelChange)="eventChange()" [min]="min" [max]="max" [(ngModel)]="rangeValues"
    [range]="true" [name]="name"></p-slider>
</div>